import { styled } from '@mui/material';
import LoginInputs from 'components/Login/LoginInputs';
import LanguageSelect from 'components/SignUp/LanguageSelect';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/Login/PageProvider';
import { useContext } from 'react';
import { Logo, Stack } from 'shell/components';

const Mobile = () => {
    const { device } = useViewport();
    const { country, errors, form, handleChange, handleClickButton, signInWithGoogle } = useContext(PageContext);
    return (
        <RootStack alignItems={'center'} spacing={2}>
            <Logo device={'desktop'} />
            <LoginInputs
                country={country}
                errors={errors}
                device={device}
                form={form}
                handleChange={handleChange}
                handleClickButton={handleClickButton}
                signInWithGoogle={signInWithGoogle}
            />
            <Stack sx={{ mt: 10 }}>
                <LanguageSelect />
            </Stack>
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme }) => {
    return {
        width: '100%',
        height: '100%',
        paddingTop: theme.spacing(20),
        background: theme.palette.ensightful.neutral[50],
    };
});

export default Mobile;
